module.exports = __webpack_public_path__ + "static/images/components/RewardMoney/images/bonds-small.b9467749.png";


//////////////////
// WEBPACK FOOTER
// ./components/RewardMoney/images/bonds-small.png
// module id = 2669
// module chunks = 11